import React from 'react';

export default function IcMenos() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14">
        <path fill="#000" fillRule="evenodd" d="M7 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0 .522C3.98 1.522 1.522 3.979 1.522 7c0 3.02 2.457 5.478 5.478 5.478 3.02 0 5.478-2.457 5.478-5.478 0-3.02-2.457-5.478-5.478-5.478zm3.13 5.217c.144 0 .261.117.261.261 0 .144-.117.26-.26.26H3.87c-.144 0-.261-.116-.261-.26 0-.144.117-.26.26-.26h6.261z"/>
    </svg>
  );
}
